<template>
  <div>
    <Card class="flex">
      <template #content>
        <div>
          <div class="flex text-2xl">
            <!-- <b><p class="inline mr-1">{{ actuationsTypeName }}</p> {{ !inputSwitchActuationStatus ? 'EN CURSO' : 'VENCIDOS' }}</b> -->
          </div>
          <div class="flex justify-content-center mt-5">
            <label
              for="canDelete"
              class="mr-3"
              :class="{ 'font-bold': !inputSwitchActuationStatus }"
              >En curso</label
            >
            <InputSwitch v-model="inputSwitchActuationStatus" />
            <label for="canDelete" class="ml-3" :class="{ 'font-bold': inputSwitchActuationStatus }"
              >Vencidos</label
            >
          </div>
          <Chart
            type="pie"
            :data="chartData"
            :options="chartOptions"
            class="mt-3"
            v-if="!showProgressSpinner"
          />
          <ProgressSpinner
            style="width: 50px; height: 50px"
            strokeWidth="5"
            fill="#EEEEEE"
            animationDuration="1.8s"
            class="flex justify-content-center mt-5"
            v-if="showProgressSpinner"
          />
        </div>
      </template>
    </Card>
  </div>
</template>
<script setup>
import { onMounted, watch } from "vue";
import Chart from "primevue/chart";
import { useDashboardStatistics } from "@/composables/useDashboardStatistics";

const props = defineProps({
  dependencia: {
    type: String,
    default: null,
  },
});

const {
  chartData,
  chartOptions,
  inputSwitchActuationStatus,
  showProgressSpinner,
  getData,
  setDependencia,
} = useDashboardStatistics();

onMounted(async () => {
  showProgressSpinner.value = true;
  const basicUrl = process.env.VUE_APP_BACKEND_ENVIRONMENT;
  const search = [
    {
      "exp_pre_EstadoActuacion.TipoEstadoActuacionID": [{ operator: "=", value: "En Curso" }],
    },
    {
      "exp_pre_EstadoActuacion.TipoEstadoActuacionID": [{ operator: "=", value: "Vencida" }],
    },
  ];
  const paramsPendientes = `search=${JSON.stringify(search[0])}`;
  const paramsVencidos = `search=${JSON.stringify(search[1])}`;
  await getData([
    `${basicUrl}/Actuacion/estadisticas?${paramsPendientes}`,
    `${basicUrl}/Actuacion/estadisticas?${paramsVencidos}`,
  ]);
});

watch(
  () => props.dependencia,
  (actual = "") => {
    showProgressSpinner.value = true;
    setDependencia(actual);
  }
);
</script>
<style>
.logo {
  display: flex;
  justify-content: center;
}
</style>
